import { inject, injectable } from 'libs/uikit/ioc';
import { IAuthenticationStore } from './Abstractions/IAuthenticationStore';
import type { IUserDirector } from './Abstractions/IUserDirector';

@injectable()
export class UserDirector implements IUserDirector {
  constructor(@inject(IAuthenticationStore) private authenticationStore: IAuthenticationStore) {}

  getLandingPagePath(): string {
    if (!this.authenticationStore.isAuthenticated) {
      return '/account/login';
    }

    // A role name that corresponds to the role [Name] db column.
    const role = this.authenticationStore.profile?.roles?.[0];

    switch (role) {
      // the following roles go to the event management portal
      case 'super_admin':
      case 'marketplace_owner':
      case 'marketplace_editor':
      case 'support_admin':
      case 'sales_admin':
      case 'partner_admin':
      case 'marketplace_verification_manager':
      case 'contractor':
        return '/#/ticreg/UserHub/';

      // the following roles go to vendor pages
      case 'vendor_admin':
        return '/#/ticreg/vendor-welcome-hub';

      // the following role is for event customers who
      // go to their profile page
      case 'registered_customer':
        return '/MyProfile';

      // the following roles are unaccounted for and
      // go to a 404 page (unused roles)
      case 'support_staff':
      case 'sales_staff':
      case 'partner_staff':
      case 'vendor_editor':
      default:
        return '/404';
    }
  }
}
